import PropTypes from 'prop-types';
import CustomText from '@components/shared/CustomText';
import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import CustomCheckbox from '@components/shared/CustomCheckbox';
import { DROPDOWN_VALUES } from '@features/DocViewer/Steps/Docs/DocTableRow/constants';
import styles from './CustomDropdown.module.scss';

const CustomDropdown = ({
  items,
  open,
  setIsOpen,
  onSelect,
  minWidth,
  isCheckbox,
}) => {
  const dropdownRef = useRef();
  const myRef = useRef();

  useEffect(() => {
    if (open) {
      const dropdown = dropdownRef.current;
      const { bottom } = dropdown.getBoundingClientRect();
      const dropdownHeight = dropdown.offsetHeight;
      const isEnoughSpaceBelow = window.innerHeight - bottom > dropdownHeight;
      if (!isEnoughSpaceBelow)
        myRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [open]);

  const handleClick = (event, item) => {
    event.stopPropagation();
    item.onClick ? item.onClick(event) : onSelect(item);
    item.value !== DROPDOWN_VALUES.SHARE && setIsOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      style={{ minWidth }}
      className={clsx(styles.container, open && styles.visible)}
    >
      {items?.map(item => (
        <button
          disabled={item.disabled}
          key={item.value}
          className={styles.item}
          onClick={event => handleClick(event, item)}
        >
          {isCheckbox && (
            <CustomCheckbox checked={item.isSelected} readOnly small />
          )}
          {item.icon && (
            <div className={clsx(open && styles.show, styles.icon)}>
              {item.icon}
            </div>
          )}
          <CustomText customStyle={'body1'}>{item.value}</CustomText>
        </button>
      ))}
      <div ref={myRef} />
    </div>
  );
};

CustomDropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      icon: PropTypes.node,
    }),
  ),
  open: PropTypes.bool,
  setIsOpen: PropTypes.func,
  isCheckbox: PropTypes.bool,
  onSelect: PropTypes.func,
  minWidth: PropTypes.number,
};

export default CustomDropdown;
